let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("80srp")).then(() => parcelRequire('229rK'));